import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "data-protection-laws-hyderabad-it-teams-us-clients": {
    id: 9,
    title: "Data Protection Laws for Hyderabad IT Teams | Cyber Security",
    category: "Data Protection",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "Septermber 03, 2026",
    author: "TechProjects",
    readTime: "10 minutes",
    excerpt:
      "Hyderabad's IT industry is becoming increasingly connected to US businesses, with technology teams supporting software development, cloud computing, artificial intelligence, IT consulting and managed services.",
    content: [
      {
        type: "heading2",
        text: "Why Data Protection Laws Matter for Hyderabad-Based IT Teams Serving US Clients",
      },
      {
  type: "paragraph",
  text: 'Hyderabad\'s IT industry is becoming increasingly connected to US businesses, with technology teams supporting software development, cloud computing, artificial intelligence, IT consulting and managed services. As these projects involve customer and business data, data protection laws and cybersecurity compliance are becoming critical priorities.',
},
{
  type: "paragraph",
  text: 'For companies handling international projects, working with experienced <a href="https://techprojects.com/blog/cybersecurity-compliances-companies-in-hyderabad" class="text-blue-600 hover:text-blue-800 font-semibold">cyber security compliance companies in India</a> can help strengthen security practices and prepare teams for the compliance expectations of US clients.',
},

{
  type: "heading2",
  text: "Hyderabad's IT Sector Has a Global Role",
},
{
  type: "paragraph",
  text: "Hyderabad has developed into a major technology and Global Capability Centre (GCC) hub. IT teams across the city support US businesses in sectors such as healthcare, financial services, pharmaceuticals, retail and technology.",
},
{
  type: "paragraph",
  text: "These engagements may involve personal information, financial records, intellectual property and confidential business data. Protecting this information is essential for maintaining client trust and meeting contractual and regulatory requirements.",
},
{
  type: "paragraph",
  text: "As international projects become more complex, cybersecurity compliance is increasingly becoming part of vendor selection, client audits and technology partnerships.",
},

{
  type: "heading2",
  text: "Why US Clients Expect Strong Data Protection",
},
{
  type: "paragraph",
  text: "US businesses working with Hyderabad-based IT teams often have specific privacy and cybersecurity requirements. Depending on the project and industry, clients may expect controls covering data access, encryption, monitoring, incident response, data retention and third-party risk.",
},
{
  type: "paragraph",
  text: "This has increased demand for specialised cybersecurity expertise. Cyber security compliance companies in India can help technology organisations assess their security controls and prepare for enterprise client requirements.",
},
{
  type: "paragraph",
  text: "At the same time, US organisations may work with cyber security compliance companies in New Jersey to address regional business and regulatory expectations. Coordination between teams in India and the US can create a more consistent approach to data protection.",
},

{
  type: "heading2",
  text: "DPDP Act and Data Governance",
},
{
  type: "paragraph",
  text: "India's Digital Personal Data Protection framework has made responsible handling of digital personal data increasingly important for businesses.",
},
{
  type: "paragraph",
  text: "Hyderabad IT teams should understand what data is collected, why it is processed, where it is stored and who can access it. Companies should also establish appropriate processes for data retention, deletion, security incidents and third-party access.",
},
{
  type: "paragraph",
  text: "For projects involving US clients, Indian data-protection requirements may also need to be considered alongside contractual obligations and applicable US privacy requirements.",
},

{
  type: "heading2",
  text: "Cross-Border Data Needs Careful Management",
},
{
  type: "paragraph",
  text: "International technology projects can involve employees, cloud platforms, applications and vendors across different countries. Maintaining a clear data-flow process helps organisations identify potential compliance risks.",
},
{
  type: "paragraph",
  text: "Teams should know:",
},
{
  type: "bulletList",
  items: [
    "What personal or confidential data is being processed",
    "Where the information is stored",
    "Who has access to it",
    "Whether data is transferred internationally",
    "Which vendors receive the information",
    "How long data is retained",
    "How security incidents are handled"
  ],
},
{
  type: "paragraph",
  text: "Clear documentation can make compliance assessments easier and provide greater confidence to international clients.",
},

{
  type: "heading2",
  text: "Cybersecurity Is Part of Data Protection",
},
{
  type: "paragraph",
  text: "Effective data protection requires both policies and technical safeguards. Hyderabad-based IT teams serving US customers should consider measures such as:",
},
{
  type: "bulletList",
  items: [
    "Multi-factor authentication",
    "Role-based access control",
    "Data encryption",
    "Vulnerability assessments",
    "Security monitoring",
    "Backup and recovery",
    "Incident-response planning",
    "Employee security training",
    "Third-party risk assessments"
  ],
},
{
  type: "paragraph",
  text: "Experienced cyber security compliance companies in India can assist organisations with identifying security gaps, improving controls and preparing for client assessments.",
},

{
  type: "heading2",
  text: "AI Creates New Privacy Challenges",
},
{
  type: "paragraph",
  text: "Artificial intelligence is creating additional data-protection challenges for technology companies. Hyderabad teams are increasingly involved in AI development, automation and analytics.",
},
{
  type: "paragraph",
  text: "When personal or confidential information is used in AI systems, organisations need to understand how the data is collected, processed, stored and protected. Privacy and cybersecurity reviews should therefore be incorporated into AI projects from the beginning.",
},

{
  type: "heading2",
  text: "Building Trust With US Clients",
},
{
  type: "paragraph",
  text: "Strong cybersecurity compliance can provide benefits beyond regulatory requirements. US enterprises increasingly want technology providers that can demonstrate effective security controls and responsible data-management practices.",
},
{
  type: "paragraph",
  text: 'For Hyderabad companies serving New Jersey and other US markets, understanding the expectations addressed by <a href="https://techprojects.com/Services/CSC" class="text-blue-600 hover:text-blue-800 font-semibold">cyber security compliance companies in New Jersey</a> can help improve preparedness for security assessments and client discussions.',
},
{
  type: "paragraph",
  text: "This approach can strengthen vendor relationships and support long-term international business opportunities.",
},

{
  type: "heading2",
  text: "Conclusion",
},
{
  type: "paragraph",
  text: "As Hyderabad's IT sector expands its role in the US technology market, data protection is becoming an essential part of global service delivery.",
},
{
  type: "paragraph",
  text: "By strengthening privacy practices, implementing effective cybersecurity controls and working with reliable cyber security compliance companies in India, Hyderabad-based IT teams can better prepare for international requirements. Understanding the role of cyber security compliance companies in New Jersey can also help organisations align their practices with US client expectations.",
},
{
  type: "paragraph",
  text: "Ultimately, effective data protection is not simply about compliance. It is about protecting information, building client trust and creating a stronger foundation for sustainable growth in the global technology market.",
},

{
  type: "heading2",
  text: "Frequently Asked Questions",
},

{
  type: "heading3",
  text: "1. Why do data protection laws matter for Hyderabad-based IT teams serving US clients?",
},
{
  type: "paragraph",
  text: "Data protection laws help Hyderabad-based IT teams protect sensitive information, meet client security requirements, and reduce the risk of data breaches. Tech Projects Hyderabad supports businesses with technology and IT solutions that can help strengthen secure digital operations.",
},

{
  type: "heading3",
  text: "2. What data protection laws should Hyderabad IT companies follow when serving US clients?",
},
{
  type: "paragraph",
  text: "Companies may need to comply with India's Digital Personal Data Protection (DPDP) framework as well as applicable US privacy, security, industry, and contractual requirements. Businesses should assess requirements based on the type of data they handle and the services they provide.",
},

{
  type: "heading3",
  text: "3. How can cyber security compliance companies in India help Hyderabad IT businesses?",
},
{
  type: "paragraph",
  text: "Cyber security compliance companies in India help organizations identify security risks, implement appropriate controls, improve data protection policies, and prepare for compliance assessments. Technology partners such as Tech Projects Hyderabad can also support businesses with secure IT infrastructure and digital solutions.",
},

{
  type: "heading3",
  text: "4. Why is cybersecurity compliance important for companies working with US clients?",
},
{
  type: "paragraph",
  text: "US clients increasingly expect technology partners to demonstrate strong cybersecurity, privacy controls, access management, and incident-response processes. Working with experienced cyber security compliance companies in New Jersey or India can help businesses meet these expectations and build long-term client trust.",
},

{
  type: "heading3",
  text: "5. How can Tech Projects Hyderabad help businesses improve data security?",
},
{
  type: "paragraph",
  text: "Tech Projects Hyderabad can support businesses through technology consulting, digital transformation, IT solutions, and secure technology practices. Combining strong technology infrastructure with effective cybersecurity and data governance can help Hyderabad-based teams serve US clients more confidently.",
},
      

    ],
    relatedArticles: [
      {
        title: "Cloud Migration Best Practices",
        image:
          "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
        category: "Cloud",
        slug: "cloud-migration-best-practices",
      },
      {
        title: "React Performance Optimization",
        image:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
        category: "React",
        slug: "react-performance-optimization",
      },
      {
        title: "DevOps Automation with CI/CD",
        image:
          "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
        category: "DevOps",
        slug: "devops-automation-cicd",
      },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  // useEffect(() => {
  //   const fetchMetaData = async () => {
  //     const data = await getPagesBySlug(slug);
  //     setMetaData(data?.meta || {});
  //   };
  //   fetchMetaData();
  // }, [slug]);
  // slug = useParams();
 useEffect(() => {
  const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };

      fetchData();},[slug]);
  // console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["data-protection-laws-hyderabad-it-teams-us-clients"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
          case "table":
  return (
    <div key={index} className="overflow-x-auto mb-6">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            {section.headers.map((header, i) => (
              <th
                key={i}
                className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-900"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {section.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="border border-gray-300 px-4 py-3 text-gray-700"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Discover why Hyderabad IT teams serving US clients need data protection and how cyber security compliance companies in New Jersey support global compliance.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
